<template>
  <form-request
    v-if="src"
    :action="src"
    method="post"
    v-slot="{ update, submit, errors }"
  >
    <popup-form
      title="Assign To Product"
      button="Assign"
      :show="show"
      @close="$emit('close')"
      @confirm="assignToProduct(update, submit)"
    >
      <div class="input-group col-span-12 sm:col-span-4">
        <error
          :errors="errors"
          name="product"
        />
        <ComboBox
          :data="products"
          :filter-on="'name'"
          :label="(item) => (item ? `${item.name}` : 'Search for Product')"
          :current-selection="form.product ? products.find((product) => product.id === form.product) : null"
          @update="(product) => (form.product = product.id)"
        />
        <span class="text-xs text-gray-600">Minimum 3 characters</span>
      </div>
    </popup-form>
  </form-request>
</template>

<script>
import PopupForm from '@/Components/Forms/PopupForm'
import FormRequest from '@/Components/Forms/FormRequest'
import Error from '@/Components/Forms/Error'
import ComboBox from '@/Components/Forms/ComboBox'

export default {
  components: {
    PopupForm,
    FormRequest,
    Error,
    ComboBox
  },
  emits: ['close'],

  props: {
    /**
     * If true we display the form
     */
    show: {
      type: Boolean,
      default: false
    },
    /**
     * A list of locations we can transfer a package to
     */
    products: {
      type: Array,
      default() {
        return []
      }
    },
    /**
     * The route to send the transfer request to. If null we can't send a package and thus don't show the form
     */
    src: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      // The form that gets submitted to the server
      form: { product: null }
    }
  },

  methods: {
    /**
     * Submits 'assign product' request to the server
     * @param update a function (passed by form-request) that sets the values to send to the server
     * @param submit a function (passed by form-request) that submits the form
     */
    assignToProduct(update, submit) {
      update({ ...this.form })
      submit()
      this.$emit('close')
    }
  }
}
</script>
